import { designToken, quickProperty } from '../component-tokens';
import { tertiaryElement, tertiaryElementHover, tertiaryElementFocus, tertiaryElementActive, buttonBase, tertiaryNeutralElement, primaryElementFocus, secondaryElementFocus, } from './common';
export const baseSmallIcon = {
    '--goto-icon-size': quickProperty('16px'),
};
export const baseMediumIcon = {
    '--goto-icon-size': quickProperty('18px'),
};
export const baseLargeIcon = {
    '--goto-icon-size': quickProperty('20px'),
};
const baseXLargeIcon = {
    '--goto-icon-size': quickProperty('22px'),
};
export const buttonBaseAttributes = Object.assign(Object.assign({}, buttonBase), { display: quickProperty('inline-flex'), 'align-items': quickProperty('center'), 'justify-content': quickProperty('center'), font: designToken('button-text-medium'), height: quickProperty('36px'), padding: quickProperty('var(--goto-button-padding, 0 16px)'), 'min-width': quickProperty('var(--goto-button-min-width, 80px)') });
export const neutralButton = {
    attributes: {
        color: designToken('text-01'),
        'background-color': designToken('interactive-02'),
        'border-color': designToken('border'),
        '--goto-icon-color': designToken('text-01'),
    },
    states: [
        {
            name: 'hover',
            attributes: {
                'background-color': designToken('hover-secondary'),
                'border-color': designToken('border'),
            },
        },
        {
            name: 'focus',
            attributes: Object.assign({}, secondaryElementFocus),
        },
        {
            name: 'active',
            attributes: {
                'background-color': designToken('pressed-secondary'),
                'border-color': designToken('border'),
                'box-shadow': quickProperty('none'),
            },
        },
    ],
};
export const buttonTokens = {
    name: 'button',
    tag: 'chameleon-button',
    reactImports: 'Button',
    attributes: buttonBaseAttributes,
    children: [
        {
            name: 'icon-start',
            attributes: Object.assign(Object.assign({}, baseMediumIcon), { margin: quickProperty('0 7px 0px -5px') }),
        },
        {
            name: 'icon-end',
            attributes: Object.assign(Object.assign({}, baseMediumIcon), { margin: quickProperty('0 -5px 0px 7px') }),
        },
    ],
    sizes: [
        {
            name: 'small',
            attributes: {
                font: designToken('button-text-small'),
                height: quickProperty('30px'),
                padding: quickProperty('var(--goto-button-padding, 0 14px)'),
            },
            children: [
                {
                    name: 'icon-start',
                    attributes: Object.assign(Object.assign({}, baseSmallIcon), { margin: quickProperty('0 6px 0px -4px') }),
                },
                {
                    name: 'icon-end',
                    attributes: Object.assign(Object.assign({}, baseSmallIcon), { margin: quickProperty('0 -4px 0px 6px') }),
                },
            ],
        },
        {
            name: 'large',
            attributes: {
                font: designToken('button-text-large'),
                height: quickProperty('42px'),
                padding: quickProperty('var(--goto-button-padding, 0 20px)'),
            },
            children: [
                {
                    name: 'icon-start',
                    attributes: Object.assign(Object.assign({}, baseLargeIcon), { margin: quickProperty('0 10px -2px -5px') }),
                },
                {
                    name: 'icon-end',
                    attributes: Object.assign(Object.assign({}, baseLargeIcon), { margin: quickProperty('0 -5px -2px 10px') }),
                },
            ],
        },
        {
            name: 'xlarge',
            attributes: {
                font: designToken('button-text-xlarge'),
                height: quickProperty('48px'),
                padding: quickProperty('var(--goto-button-padding, 0 24px)'),
            },
            children: [
                {
                    name: 'icon-start',
                    attributes: Object.assign(Object.assign({}, baseXLargeIcon), { margin: quickProperty('0 12px -2px -5px') }),
                },
                {
                    name: 'icon-end',
                    attributes: Object.assign(Object.assign({}, baseXLargeIcon), { margin: quickProperty('0 -5px -2px 12px') }),
                },
            ],
        },
    ],
    variants: [
        {
            name: 'primary',
            attributes: {
                'background-color': designToken('interactive-01'),
                'border-color': designToken('interactive-01'),
                color: designToken('text-06'),
                '--goto-icon-color': designToken('text-06'),
            },
            states: [
                {
                    name: 'hover',
                    attributes: {
                        'background-color': designToken('hover-primary'),
                        'border-color': designToken('hover-primary'),
                    },
                },
                {
                    name: 'focus',
                    attributes: Object.assign({}, primaryElementFocus),
                },
                {
                    name: 'active',
                    attributes: {
                        'background-color': designToken('pressed-primary'),
                        'border-color': designToken('pressed-primary'),
                        'box-shadow': quickProperty('none'),
                    },
                },
            ],
        },
        {
            name: 'secondary',
            attributes: {
                color: designToken('link'),
                '--goto-icon-color': designToken('link'),
                'border-color': designToken('border'),
                'background-color': designToken('interactive-02'),
            },
            states: [
                {
                    name: 'hover',
                    attributes: {
                        'background-color': designToken('hover-secondary'),
                    },
                },
                {
                    name: 'focus',
                    attributes: Object.assign({}, secondaryElementFocus),
                },
                {
                    name: 'active',
                    attributes: {
                        'background-color': designToken('pressed-secondary'),
                        'box-shadow': quickProperty('none'),
                    },
                },
            ],
        },
        {
            name: 'tertiary',
            attributes: Object.assign({}, tertiaryElement),
            states: [
                {
                    name: 'hover',
                    attributes: Object.assign({}, tertiaryElementHover),
                },
                {
                    name: 'focus',
                    attributes: Object.assign({}, tertiaryElementFocus),
                },
                {
                    name: 'active',
                    attributes: Object.assign({}, tertiaryElementActive),
                },
            ],
        },
        {
            name: 'tertiary-neutral',
            attributes: Object.assign({}, tertiaryNeutralElement),
            states: [
                {
                    name: 'hover',
                    attributes: Object.assign({}, tertiaryElementHover),
                },
                {
                    name: 'focus',
                    attributes: Object.assign({}, tertiaryElementFocus),
                },
                {
                    name: 'active',
                    attributes: Object.assign({}, tertiaryElementActive),
                },
            ],
        },
        {
            name: 'success',
            attributes: {
                color: designToken('text-06'),
                '--goto-icon-color': designToken('text-06'),
                'border-color': designToken('success-01'),
                'background-color': designToken('success-01'),
            },
            states: [
                {
                    name: 'hover',
                    attributes: {
                        'background-color': designToken('hover-success'),
                        'border-color': designToken('hover-success'),
                    },
                },
                {
                    name: 'focus',
                    attributes: {
                        'border-color': designToken('focus-success'),
                        'box-shadow': designToken('highlight-success'),
                    },
                },
                {
                    name: 'active',
                    attributes: {
                        'background-color': designToken('pressed-success'),
                        'border-color': designToken('pressed-success'),
                        'box-shadow': quickProperty('none'),
                    },
                },
            ],
        },
        {
            name: 'danger',
            attributes: {
                'background-color': designToken('danger-01'),
                'border-color': designToken('danger-01'),
                color: designToken('text-06'),
                '--goto-icon-color': designToken('text-06'),
            },
            states: [
                {
                    name: 'hover',
                    attributes: {
                        'background-color': designToken('hover-danger'),
                        'border-color': designToken('hover-danger'),
                    },
                },
                {
                    name: 'focus',
                    attributes: {
                        'border-color': designToken('focus-danger'),
                        'box-shadow': designToken('highlight-error'),
                    },
                },
                {
                    name: 'active',
                    attributes: {
                        'background-color': designToken('pressed-danger'),
                        'border-color': designToken('pressed-danger'),
                        'box-shadow': quickProperty('none'),
                    },
                },
            ],
        },
        {
            name: 'disabled',
            attributes: {
                'background-color': designToken('disabled-02'),
                'border-color': quickProperty('transparent'),
                color: designToken('text-03'),
                cursor: quickProperty('default'),
                '--goto-icon-color': designToken('text-03'),
            },
            states: [
                {
                    name: 'hover',
                    attributes: {
                        'background-color': designToken('disabled-02'),
                        'border-color': designToken('disabled-02'),
                        color: designToken('text-03'),
                    },
                },
                {
                    name: 'focus',
                    attributes: {
                        'background-color': designToken('disabled-02'),
                        'border-color': designToken('disabled-02'),
                        color: designToken('text-03'),
                    },
                },
                {
                    name: 'active',
                    attributes: {
                        'background-color': designToken('disabled-02'),
                        'border-color': designToken('disabled-02'),
                        color: designToken('text-03'),
                    },
                },
            ],
        },
        {
            name: 'disabled-secondary',
            attributes: {
                'background-color': designToken('interactive-02'),
                'border-color': designToken('disabled-04'),
                color: designToken('text-03'),
                '--goto-icon-color': designToken('text-03'),
            },
        },
        {
            name: 'disabled-tertiary',
            attributes: {
                'background-color': designToken('interactive-02'),
                'border-color': designToken('interactive-02'),
                color: designToken('text-03'),
                '--goto-icon-color': designToken('text-03'),
            },
        },
        Object.assign(Object.assign({}, neutralButton), { name: 'neutral' }),
        Object.assign(Object.assign({}, neutralButton), { name: 'neutral-inverse', attributes: {
                color: designToken('inverse-02'),
                '--goto-icon-color': designToken('inverse-02'),
                'background-color': designToken('interactive-02'),
                'border-color': designToken('button-neutral-inverse-border'),
            }, states: [
                {
                    name: 'hover',
                    attributes: {
                        'background-color': designToken('button-neutral-inverse-background-hover'),
                        'border-color': designToken('inverse-border'),
                    },
                },
                {
                    name: 'focus',
                    attributes: Object.assign({}, secondaryElementFocus),
                },
                {
                    name: 'active',
                    attributes: {
                        'background-color': designToken('button-neutral-inverse-background-active'),
                        'border-color': designToken('inverse-border'),
                        'box-shadow': quickProperty('none'),
                    },
                },
            ] }),
    ],
};
